import { useEffect, useRef } from "react";

export default function HeroSection() {
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) return;
    el.style.opacity = "0";
    el.style.transform = "translateY(30px)";
    setTimeout(() => {
      el.style.transition = "opacity 0.9s ease, transform 0.9s ease";
      el.style.opacity = "1";
      el.style.transform = "translateY(0)";
    }, 200);
  }, []);

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/2f94aa2645b326d54bd21b28c4a6ea0c.jpg"
          alt="hero background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#080C14]/70 via-[#080C14]/50 to-[#080C14]/90" />
      </div>

      {/* Decorative rings */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full border border-teal-500/10 animate-spin" style={{ animationDuration: "30s" }} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full border border-teal-500/10 animate-spin" style={{ animationDuration: "20s", animationDirection: "reverse" }} />

      {/* Content */}
      <div className="relative z-10 text-center px-4 w-full max-w-5xl mx-auto">
        {/* Company name badge */}
        <div className="inline-flex items-center gap-2 bg-teal-500/10 border border-teal-500/30 rounded-full px-5 py-2 mb-8">
          <img
            src="https://public.readdy.ai/ai/img_res/de66027b-33b2-474e-82bc-b57a53ac7665.png"
            alt="LINIJE d.o.o."
            className="w-5 h-5 object-contain"
          />
          <span className="text-teal-400 text-sm font-semibold tracking-widest uppercase">LINIJE d.o.o.</span>
        </div>

        <h1
          ref={titleRef}
          className="text-white font-bold leading-tight mb-6"
          style={{ fontSize: "clamp(2.5rem, 6vw, 5rem)" }}
        >
          Modern iOS Applications
          <br />
          <span className="text-teal-400">Built for the Future</span>
        </h1>

        <p className="text-white/60 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
          We craft powerful iOS experiences — from cutting-edge VPN security to intelligent device optimization.
          Every product is designed to protect, perform, and delight.
        </p>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/30 text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-6 h-10 rounded-full border-2 border-white/20 flex items-start justify-center pt-2">
          <div className="w-1.5 h-1.5 rounded-full bg-teal-400" />
        </div>
      </div>
    </section>
  );
}
